import { render, staticRenderFns } from "./selectorsMobile.vue?vue&type=template&id=c4a2d366&scoped=true"
import script from "./selectorsMobile.vue?vue&type=script&lang=js"
export * from "./selectorsMobile.vue?vue&type=script&lang=js"
import style0 from "./selectorsMobile.vue?vue&type=style&index=0&id=c4a2d366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a2d366",
  null
  
)

export default component.exports